import { request } from './client.js';

export async function getRecipes(category) {
  const url = category ? `/api/recipes?category=${encodeURIComponent(category)}` : '/api/recipes';
  const data = await request(url, { method: 'GET' });
  return data.recipes || [];
}

export async function getRecipe(id) {
  const data = await request(`/api/recipes/${id}`, { method: 'GET' });
  return data.recipe;
}

export async function createRecipe(recipeData) {
  return await request('/api/recipes', {
    method: 'POST',
    body: JSON.stringify(recipeData),
  });
}

export async function updateRecipe(id, recipeData) {
  return await request(`/api/recipes/${id}`, {
    method: 'PUT',
    body: JSON.stringify(recipeData),
  });
}

export async function updateRecipeNutrition(id, nutritionFacts) {
  return await request(`/api/recipes/${id}/nutrition`, {
    method: 'PATCH',
    body: JSON.stringify({ nutritionFacts }),
  });
}

export async function deleteRecipe(id) {
  return await request(`/api/recipes/${id}`, {
    method: 'DELETE',
  });
}
